import React from 'react'
import LazyLoad from 'react-lazyload'
import { screen } from '../../../styles'
import { CSSObject } from '@emotion/react'

import { useRecipe } from '../../../model/context'
import { useRecipeImage } from './useRecipeImage'
import { withCitrusTheme, DisplayPosition } from '@gousto-internal/citrus-react'

const StyledImage = withCitrusTheme('img', () => ({
  position: DisplayPosition.Absolute,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transform: 'scale(1.1)',
  [`@media ${screen.screenSMMin}`]: {
    position: DisplayPosition.Relative,
  },
}))

export const Image = ({
  lazy,
  useHomepageImage = false,
}: {
  lazy?: boolean
  styles?: CSSObject
  useHomepageImage?: boolean
}) => {
  const { title } = useRecipe()

  const recipeImage = useRecipeImage(useHomepageImage)

  if (!recipeImage) {
    return null
  }

  const [image, srcSet] = recipeImage

  const imageComponent = (
    <StyledImage
      alt={title}
      src={image}
      srcSet={srcSet}
      sizes="(max-width: 500px) 700px, (max-width: 991px) 1000px, 700px"
    />
  )

  if (lazy) {
    return (
      <LazyLoad once offset={200} height={0}>
        {imageComponent}
      </LazyLoad>
    )
  }

  return imageComponent
}
